import { render, staticRenderFns } from "./ImmigrationForm.vue?vue&type=template&id=638b478d&"
import script from "./ImmigrationForm.vue?vue&type=script&lang=js&"
export * from "./ImmigrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports